<template>
    <v-container class="pa-0 ma-0" fluid>
      <v-row class="mb-0 pb-0">
        <v-col cols="10" md="6">
            <v-text-field
              label=""
              placeholder="Usuarios...."
              class="caption"
              v-model="fieldSearch"
              @keyup.enter="loadUsuarios"
              filled
              dense
              hide-details
            ></v-text-field>
        </v-col>
        <v-col cols="2" md="6" class="my-2">
          <v-btn  tile medium color="primary" icon @click="loadUsuarios" :loading="loadingSearch">
            <v-icon medium>fa-search</v-icon>
          </v-btn>          
        </v-col>
      </v-row>
			<v-row class="px-0 py-0">
				<v-col cols=12 >
          <v-data-table
            :headers="headers"
            dense
            :items.sync="usuarios"
            :fixed-header="true"
            :loading="loadingSearch"
            min-height="200px"
            height="320px"
            class="elevation-2"     
            hide-default-footer
            :page.sync="page"
            :items-per-page="itemsPerPage"          
            @page-count="pageCount = $event"
    
            :mobile-breakpoint=100
          >
            <template v-slot:top>
              <v-toolbar flat dense color="white">
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2"  @click="newItem()">+</v-btn>
              </v-toolbar>
            </template>


            <template v-slot:item="{item,headers} ">
              <tr class="body-2">
                <template v-for="(h, idx) in headers" >
                  <td v-if="h.value=='completo'"  :align="h.align" :key="idx" :class="['body-2', h.class]"> 
                    <v-simple-checkbox dense :value="item[h.value]?true:false" disabled></v-simple-checkbox>
                  </td>
                  <td v-else-if="h.value=='actions'" :align="h.align" :key="idx" :class="[ h.class]" class="px-1">
                    <v-icon
                      small
                      class="mx-3"
                      @click="editItem(item)"
                    >
                      fa fa-pencil
                    </v-icon>
                    <v-icon
                      small
                      class="mx-3"
                      @click="deleteItem(item)"
                    >
                      fa fa-trash-o
                    </v-icon>
                  </td>
                  <td  v-else-if="h.type=='date'" :align="h.align" :key="idx" :class="['caption', h.class]"> 
                    {{ item[h.value] | DDMMAAAA }} 
                  </td>
                  <td  v-else :align="h.align" :key="idx" :class="['caption', h.class]" v-text="item[h.value]" />
                </template> 
              </tr>
            </template>


            <template v-slot:footer>
              <v-divider></v-divider>
              <v-row dense class="caption px-2">
                <v-col cols=12>
                  <v-btn class="ma-2" small tile outlined color="primary" @click="exportXLS" :disabled="!items.length>0">
                    <v-icon left>fa fa-file-excel-o</v-icon> Export
                  </v-btn>
                </v-col>
              </v-row>
             </template>
          </v-data-table>
        </v-col>
        <v-col cols=12>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="960px" min-width="320px"  scrollable persistent >
        <PreUsuario 
          :editedIndex="editedIndex"
          :editedItem="editedItem"

          @close="dialog=false"
          @reload="loadUsuarios()"
          :key="idDialog"
        >
        </PreUsuario>
      </v-dialog>
      
    </v-container>
</template>
<script>
  import {mapGetters} from 'vuex'
  import PreUsuario from '@/components/Usuarios/Pre-Usuario'

  import xlsx from 'xlsx'

  export default {
    name: 'Usuarios',

    components: {
      PreUsuario
    },

    data: () => ({

      dialog:false,
      idDialog:0,

      usuario:"",

      headers: [
        { text: 'Razón Social' ,align: 'start',sortable: true, value: 'razonSoc', class:"text-truncate"},
        { text: 'E-Mail'       ,align: 'start',sortable: true, value: 'email', class:"text-truncate"},
        { text: 'Tipo Usr'     ,align: 'start',sortable: true, value: 'tusuario'},
        { text: 'F.Alta'       ,align: 'start',sortable: true, value: 'fecha_insert', type:"date"},
        { text: 'Completo'     ,align: 'center',sortable: false, value: 'completo'},
        { text: ''             ,align: 'end'  ,sortable: false, value: 'actions', width:"110px" },
      ],
      items:[],

      page: 1,
      pageCount: 0,
      itemsPerPage: 100,

      editedIndex: -1,
      editedItem:[],

      //INI BUSQUEDA
      loadingSearch:false,
      fieldSearch:"",
      //FIN BUSQUEDA    

    }),
    created: function () {
      //console.log("Componente creado")
      this.initialize()
    },
    mounted: function () {
      //console.log("Componente mondado")

      
    },
    watch: {
   
    },

    methods: {
      exportXLS (){

        var filename = "exportUsuarios.xlsx"

        let data=this.items.map(u => {
          return {
            Nombre:u.nombre,
            Apellido:u.apellido,
            eMail:u.email?u.email:u.emailAux,
            Celular:u.celular,
            'Tipo Usr':u.tusuario,
            Referencia:u.referencia,
            'Razón Soc':u.razonsocial?u.razonsocial:u.razonsocialAux,
            CUIT:u.cuit,
            Tel:u.telefono,
            Provincia:u.provincia,
            Localidad:u.localidad,
            CP:u.cp,
            'Tipo Emp':u.tipoEmp.map(t => t.tempresa).join(';'),
            Categorias:u.categorias.map(c => `${c.categoria}/${c.subcategoria}`).join(';'),
            Tags:u.keys.map(w => w.palabra).join(';')
          }
        })


        //var data = [[1,2,3],[true, false, null, "sheetjs"],["foo","bar",new Date("2014-02-19T14:30Z"), "0.3"], ["baz", null, "qux"]]
        var ws_name = "Usuarios";

        
        if(typeof console !== 'undefined') console.log(new Date());
        //var wb = xlsx.utils.book_new(), ws = xlsx.utils.aoa_to_sheet(data);

        var wb = xlsx.utils.book_new(), ws = xlsx.utils.json_to_sheet(data);
        
        /* add worksheet to workbook */
        xlsx.utils.book_append_sheet(wb, ws, ws_name);

        /* write workbook */
        if(typeof console !== 'undefined') console.log(new Date());
        xlsx.writeFile(wb, filename);
        if(typeof console !== 'undefined') console.log(new Date());


      },

      initialize () {
        this.loadUsuarios()
      },

      newItem() {
        this.editedIndex=-1
        this.editedItem=[]

        this.idDialog++
        this.dialog = true
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem=item
        this.idDialog++
        this.dialog = true
      },

      deleteItem (item) {
        console.log(item)
        confirm('Seguro que desea eliminar el usuario seleccionado?') && this.deleteUsuario(item.id)
      },

      async deleteUsuario(id){

        let opt={
          method: 'DELETE', 
          mode: 'cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },  
          //body: JSON.stringify(param),
        }
        let response = await fetch(`${this.ROOT_API}cms/usuarios/${id}`, opt)
        
        await this.loadUsuarios()
        
      },

      async loadUsuarios(){

        //console.log("INICIO loadUsuarios")

        this.loadingSearch=true
        this.items=[]

        let opt={
          method: 'GET', 
          mode: 'cors'
        } 

        let params=`/?_filters=${JSON.stringify({status:undefined})}&_words=${JSON.stringify(this.words)}`

        console.log("params -->  " , params)
        
        let response = await fetch(`${this.ROOT_API}cms/usuarios/${params}`, opt);

        if (response.ok){
          let r=await response.json()
          this.items=r.map(item => {
            item.email=item.completo?item.email:item.emailAux
            item.razonSoc=item.completo?item.razonsocial:item.razonsocialAux
            return item
          })
        }
        this.loadingSearch=false


      },


    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      words: function () {
        
        ////this.texto = this.texto.replace(/[^a-zA-Z0-9\ \ñ\Ñ]/g, ' ')
        return this.fieldSearch.split(' ').filter(x => x.length>2)
      },

      usuarios: function(){
        let r=this.items.filter( 
            item => item.razonSoc.toLowerCase().includes(this.usuario.toLowerCase()) ||
                    (item.email && item.email.toLowerCase().includes( this.usuario.toLowerCase())) ||
                    (item.emailAux && item.emailAux.toLowerCase().includes( this.usuario.toLowerCase()) ) ||
                    (item.tusuario && item.tusuario.toLowerCase().includes( this.usuario.toLowerCase()) )  
        )
        //console.log(r)
        return r//((r && r.length>0)  ? r.map(function(i) { return parseFloat(i.importe) }).reduce((res, item) => res=res + item) : 0).toFixed(2)
      },
    },
  }
</script>

<style lang="scss">

</style>

